import { Unauthorized } from 'components/unauthorized';
import { useCanAccess } from 'hooks/useCanAccess';
import {
  AdminRemittanceManagement,
  UserRemittanceManagement,
} from 'pages/remittance/components';
import { TokenExpired } from 'components/tokenExpired';

export const RemittanceManagementRoute = () => {
  const { canAccess, isAdmin, isExpired } = useCanAccess('remittances');

  return isExpired ? (
    <TokenExpired />
  ) : isAdmin ? (
    <AdminRemittanceManagement />
  ) : canAccess ? (
    <UserRemittanceManagement />
  ) : (
    <Unauthorized />
  );
};
